import React, { useEffect } from 'react';
import { TextLogin, Button, MainLogin } from '@lana-ui/login';
import { Formik, Form } from 'formik';
import { Text, Label, Input } from '@lana-ui/common';
import { useDispatch, useStore } from '../../Store/storeProvider';
import { stateCode } from '../../Config/Registracion';
import '@styles/Components/PinActivacion.scss';
import TerminosYcondiciones from '../Common/banner/TerminosYCondiciones';
import InputFormik from '../Common/Formik/Input';
import useValidarPinHandler from '../../Hooks/useValidarPinHandler';
import ActivarPinService from '../../Services/ActivarPinService';
import { trackCustomEvent } from '../../Config/DataDog';
import { StepsTrackeoRedimirPin } from '../../Config/StepsTrackeoRedimirPin';

const PinActivacion = ({ title, setIsLoading }) => {
    const { User, Config, HandleError } = useStore();
    const dispatch = useDispatch();
    const [handlerPin] = useValidarPinHandler();
    let url = new URL(document.location);
    let urlPin = url?.searchParams.get('pin');

    const handleSeteoKey = () => {
        //siu existe en el store o no hay en la url no seteamos
        //()
        if (Config.Pin || !urlPin) return;
        dispatch({
            type: 'SETEO_PIN',
            value: urlPin,
        });
    };
    useEffect(() => {
        handleSeteoKey();
        //Viene de logeo desp de rebotar en view pin
        //Ejecutamos automatico el send
        if (Config.ActionAuto) handleSend(Config.Pin);
        //Seteo en false para evitar el loop infinito
        dispatch({
            type: 'SETEO_ACTIONAUTO',
            value: false,
        });
        trackCustomEvent(StepsTrackeoRedimirPin[1]);
    }, []);

    let handleSend = async (pinValue) => {
        trackCustomEvent(StepsTrackeoRedimirPin[3]);
        setIsLoading(true);
        try {
            let dataValidar = {
                Pin: pinValue,
            };
            const resp = await ActivarPinService(dataValidar);
            handlerPin(resp);
        } catch (error) {
            console.log(error);
            dispatch({
                type: 'ERROR PAGE COMPONENT',
                value: 'error generico',
            });
        }
        setIsLoading(false);
    };

    return (
        <>
            <div className="activar-suscripcion">
                {title && <TextLogin title={'¡Activá tu suscripción!'} />}
                <Text as="p" size="2xs">
                    Para que la suscripción digital quede activa, ingresá el{' '}
                    código que te enviamos al email. Luego, iniciá sesión o{' '}
                    creá una cuenta en <span className="ln">LA NACION</span>.
                </Text>
            </div>
            <Formik
                initialValues={{
                    inputPin: urlPin || '',
                }}
                //validationSchema={}
                onSubmit={async (values) => {
                    await handleSend(values.inputPin);
                }}
            >
                {({ values }) => {
                    return (
                        <Form className="login-form" noValidate>
                            <MainLogin>
                                <Label text={'Código de activación'}></Label>
                                <InputFormik
                                    name="inputPin"
                                    className="--mb-8"
                                    state={
                                        HandleError?.Input &&
                                        stateCode('error', HandleError.Input)
                                    }
                                />

                                <Button
                                    as="input"
                                    label="Activar"
                                    className={'--not-disabled --mb-24'}
                                />
                            </MainLogin>
                        </Form>
                    );
                }}
            </Formik>
            <Text size="2xs" className="gray-box">
                Recordá que podés utilizar únicamente cuentas que no tengan{' '}
                suscripción digital activa
            </Text>
            <TerminosYcondiciones text="Al hacer click en Activar confirmo que he leído y aceptado los" />
        </>
    );
};

export default PinActivacion;
